export const InductLocationActions = {
    GET_INDUCT_LOCATIONS:"GET_INDUCT_LOCATIONS",
    GET_INDUCT_LOCATIONS_RESPONSE:"GET_INDUCT_LOCATIONS_RESPONSE",
    GET_INDUCT_LOCATIONS_RESPONSE_ERROR:"GET_INDUCT_LOCATIONS_RESPONSE_ERROR",
    RESET_RESPONSE:"RESET_RESPONSE",
    LOADING:"LOADING"
};